/* eslint-disable max-len */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {fetchBudgetsDates} from '../../budgetVehicles/actions/budget';

export const changeDealersAgenciesFilter = (field, value) => ({
  'type': ActionTypes.CHANGE_DEALERS_AGENCIES_FILTER,
  'payload': {field, value},
});

export const fetchDealers = ($category) => apiActionCreator({
  'endpoint': `/dealers?category=${$category}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_DEALERS_LIST,
    ActionTypes.FETCHED_DEALERS_LIST,
    [
      ActionTypes.FETCHED_DEALERS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchDealer = (dealerId) => apiActionCreator({
  'endpoint': `/dealers/${dealerId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_DEALER,
    ActionTypes.FETCHED_DEALER,
    [
      ActionTypes.FETCHED_DEALER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getAllAgencies = () => apiActionCreator({
  'endpoint': '/dealers/agencies',
  'authenticated': true,
  'types': [
    ActionTypes.GET_ALL_AGENCIES_REQUEST,
    ActionTypes.GET_ALL_AGENCIES_SUCCESS,
    [
      ActionTypes.GET_ALL_AGENCIES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchAgenciesByDealer = ({dealerId, yearFilter, monthFilter, salesReport, priorization}) =>
  (dispatch) => {
    return dispatch(
      apiActionCreator({
        'endpoint': `/dealers/${dealerId}/agencies?is-sales-report=${salesReport || 'N'}&priorization=${priorization || 'N'}`,
        'authenticated': true,
        'types': [
          ActionTypes.FETCHING_AGENCIES_BY_DEALER,
          [
            () => {
              if (yearFilter && monthFilter) {
                dispatch(fetchBudgetsDates(yearFilter, monthFilter));
              }

              return {
                'type': ActionTypes.FETCHED_AGENCIES_BY_DEALER,
              };
            },
          ],
          [
            {
              'type': ActionTypes.FETCHED_AGENCIES_BY_DEALER_FAILED,
            },
            (error) => buildErrorMessage(error),
          ],
        ],
        'microservice': 'part',
        'method': 'GET',
      }),
    );
  };

export const clearAgenciesList = () => ({
  'type': ActionTypes.CLEAR_AGENCIES_LIST,
});
